// --- Modules
import Node, { payload } from './Node';

class SecurityDevice extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Security Device'
    });
  }
};

export default {
  create: (opts) => {
    let item = new SecurityDevice(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
